class GiftWithPurchase {
  static init(){
    this.handles = ["cvg-logo-sweatshirt", "green-plaid-leggings", "vest-black", "tear-it-up-2-0-leggings-dried-sage"];
    this.giftData = [];
    this.giftThreshold = "20000"
    this.handles.forEach(handle => {
      if(handle != "") {
        fetch(`/products/${handle}.js`)
          .then(response => response.json())
          .then(data => this.giftData.push(data)); 
      }
    });

    this.cartSettings = JSON.parse(
      document.querySelector("#cart-drawer-settings").textContent
    );
  }

  static getGifts(){
    return this.giftData;
  }

  static toggle_gift_form(e){
    if(this.giftInCart()){
      this.displayModal(".have-gift-message");
      return
    }

    const form = e.target.closest(".gift-item").querySelector("form");
    form.classList.toggle("hide");
  }

  static on_gift_form_submit(e){
    e.preventDefault();

    function isArrayEqual(arr1, arr2){
      if(arr1.length !== arr2.length) return false;

      for(const val of arr1){
        if(!arr2.includes(val)) return false
      }

      return true;
    }
    
    const gift = this.getGifts().find(gift => gift.id == e.target.getAttribute("data-gift-id"))
    const values = Array.from(new FormData(e.target).values());
    
    if(gift.options.length !== values.length) return;

    const variant = gift.variants.find(variant => isArrayEqual(variant.options, values))
    console.log(variant)
    if(!variant.available){
      console.log("variant not available")
      return
    }

    this.addGiftToCart(variant.id);
  }

  static handleCheckboxChange(e){
    const siblings = e.target.parentElement.querySelectorAll("input");

    siblings.forEach(input => {
      if(!input.isSameNode(e.target)) input.checked = false;
    });

    if(e.target.getAttribute("name") === "Size") return;

    const gift = this.giftData.find(gift => gift.id == e.target.closest("form").getAttribute("data-gift-id"));

    const unavailable_variants = gift.variants.filter(variant => !variant.available && variant.options.includes(e.target.value))

    const unavailable_sizes = unavailable_variants.map(variant => {
      const [size] = variant.options.filter(option => option !== e.target.value)
      return size;
    })

    const size_inputs = e.target.closest("form").querySelectorAll("input[name='Size']");
    
    if(e.target.checked){
      size_inputs.forEach((input) => {
        if (unavailable_sizes.includes(input.value)) {
          input.checked = false;
          input.disabled = true;
        } else {
          input.disabled = false;
        }
      });
    } else {
      size_inputs.forEach(input => {
        input.disabled = false;
      })
    }
  }

  static hydrate_markup(){
    const single_variant_gift = document.querySelectorAll(
      "#cart-drawer .ajaxcart_gift .gift-button:not(.select-gift-size)"
    );
    single_variant_gift.forEach((giftButton) => {
      giftButton.addEventListener("click", function () {
        const variantId = giftButton.dataset.singleVarid;
        this.addGiftToCart(variantId);
      }.bind(this));
    });

    const toggle_form_btns = document.querySelectorAll(".select-gift-size, .ajaxcart__gift-form-close")
    toggle_form_btns.forEach(btn => btn.addEventListener("click", this.toggle_gift_form.bind(this)));

    const form_gift_with_variants = document.querySelectorAll(".ajaxcart__gift-form");
    form_gift_with_variants.forEach(form => form.addEventListener("submit", this.on_gift_form_submit.bind(this)))

    const form_checkboxes = document.querySelectorAll(
      ".ajaxcart__gift-option-input"
    );
    form_checkboxes.forEach(checkbox => checkbox.addEventListener("change", this.handleCheckboxChange.bind(this)))
  }

  //gets cart data from ajaxCart assets/ajax-cart.js.liquid
  static getCart(cart){
    this.cart = cart;

    if(this.giftInCart()){
      const gift = this.getSelectedGift(cart);

      if(gift) {
        const lineNumber = this.getLineInCart(gift);
        if(lineNumber >= 0) {
          const total_price_without_gift = this.cart.original_total_price - gift.price;
          if(this.giftThreshold > total_price_without_gift || this.giftIsOnlyItem()){
            this.removeGiftFromCart(lineNumber);
          }
        }
      }
    }
  }

  static getSelectedGift(cart){
    const selectedGift = cart.items.filter((item, index) => {
      if(item.properties === null){
        return;
      }
      if(item.properties.gift) {
        return item;
      }
    })

    return selectedGift[0];
  }

  static getLineInCart(gift) {
    let lineNumber = -1;
    for(let i = 0; i < this.cart.items.length; i++) {
      if(this.cart.items[i] == gift) {
        lineNumber = i + 1;
        break;
      }
    }
    return lineNumber;
  }

  static removeGiftFromCart(lineNumber){
    const _this = this;
    var removeData = {
      'line': lineNumber,
      'quantity': 0
    };
    fetch('/cart/change.js', {
      body: JSON.stringify(removeData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      method: 'POST'
    }).then(function(response) {
      return response.json();
    }).then(function(json) {
      if (_this.cartSettings.use_rebuy_cart) {
        window.Rebuy.SmartCart.show();
      } else {
        const sideCart = document.querySelector("side-cart");
        sideCart.renderCart(true);
      }
    }).catch(function(err) {
      /* uh oh, we have error. */
      console.error(err)
    });
  }

  static giftIsOnlyItem(){
    if(this.cart.item_count === 1) {
      if(this.cart.items[0].properties !== null){
        if(this.cart.items[0].properties.hasOwnProperty('gift')){
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  static getGiftVariant(giftId, options){
    const gift = this.giftData.filter(data => {
      if(data.id == giftId){
        return data
      }
    });

    const variant = gift[0].variants.filter(variant => {
      var titleArr = variant.title.split(' / ');
      //check if selected variants match
      var isSelectedVariant = options.sort().toString() == titleArr.sort().toString();
      if(isSelectedVariant) {
        return variant;
      }
    });
    return variant[0].id;
  }

  static giftInCart(){
    return this.cart.items.some(item => {
      if(item.properties !== null) {
        return item.properties.hasOwnProperty('gift');
      } else {
        return false;
      }
    });
    
  }

  static displayModal(selector){
    const modalSelectors = ['.no-gift-message', '.have-gift-message', '.gift-sold-out', '.do-not-qualify'];
    const giftModal = document.querySelector(".gwp__modal-bg");
    
    if(selector === '.do-not-qualify'){
      const message = document.querySelector("#gwp__do-not-qualify-msg");
      const moneyRequired = parseFloat((this.giftThreshold - this.cart.total_price) / 100).toFixed(2);
      message.textContent = `You are missing $${moneyRequired} for a free gift`;
    }
    
    giftModal.style.display = "block";

    for(let modalSelector of modalSelectors){
      if(modalSelector === selector){
        if(giftModal.querySelector(modalSelector)) {
          giftModal.querySelector(modalSelector).style.display = "flex";
        }
      } else {
        if(giftModal.querySelector(modalSelector)) {
          giftModal.querySelector(modalSelector).style.display = "none";
        }
      }
    }
  }

  static addGiftToCart(variantId){
    const _this = this; 

    if(this.giftInCart()){
      this.displayModal('.have-gift-message');
    } else {
      if(this.giftThreshold < this.cart.total_price ) {
        var addData = {
          'id': variantId,
          'quantity': 1,
          'properties': {
            'gift' : true
          }
        };
        fetch('/cart/add.js', {
          body: JSON.stringify(addData),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
          },
          method: 'POST'
        }).then(function(response) {
          return response.json();
        }).then(function(json) {
          if (_this.cartSettings.use_rebuy_cart) {
            window.Rebuy.SmartCart.show();
          } else {
            const sideCart = document.querySelector("side-cart");
            sideCart.renderCart(true);
          }
        }).catch(function(err) {
          /* uh oh, we have error. */
          console.error(err)
        });
      } else {
        this.displayModal(".do-not-qualify");
      }
    }
  }
}